import { type Inspection } from '@lib/spproject/types';
import { handleApiResult } from '@store/error';
import { apiSlice } from './apiSlice';

export interface IStatistic {
  projectCount: number;
  checklistCount: number;
  inspectionCount: number;
  dailyInspections: { dateModified: string; total: number; status?: { [K in Inspection.NoticeType]?: number; } }[];
  recentInspections: { name: string; dateModified: string; status: Inspection.NoticeType }[];
}

export const statisticApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStatistics: builder.query<IStatistic, void>({
      query: () => '/v1/statistics',
      providesTags: ['Statistic'],
      onQueryStarted: handleApiResult(),
    }),
  }),
});

export const { useGetStatisticsQuery, useLazyGetStatisticsQuery } = statisticApiSlice;
